import type { WidgetCandidatesKind, WidgetCandidatesState } from '@core/dashboard-types';
import type { PickActions } from '@core/ngrx-legacy';
import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';

const {
  actions,
  reducer: CandidatesWidgetReducer,
  selectors: CandidatesWidgetSelectors,
  namespace: CandidatesWidgetNamespace,
} = createEntityCollectionStore<WidgetCandidatesState>()('CandidatesWidget', {
  customActions: adapter => {
    const actions = getEntityCollectionActions(adapter, ({ id }) => id);

    return {
      fetchOne: (state, payload: { id: WidgetCandidatesKind; departmentIds: number[] }) =>
        actions.fetchOne(state, payload),
    };
  },
});

const CandidatesWidgetActions: PickActions<typeof actions, 'fetchOne'> = actions;

export {
  CandidatesWidgetActions,
  CandidatesWidgetReducer,
  CandidatesWidgetSelectors,
  CandidatesWidgetNamespace,
};
